module.exports = __webpack_public_path__ + "cachable/fonts/fa-regular-400.e70221c01393a280c552b46acd239071.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@fortawesome/fontawesome-pro/webfonts/fa-regular-400.svg
// module id = 1183
// module chunks = 0